import { ThemeOptions } from '@mui/material'

export const typography: ThemeOptions['typography'] = {
  fontFamily: 'Open Sans, sans-serif',
  htmlFontSize: 10,
  h1: {
    fontSize: 40,
    fontWeight: 800,
    fontFamily: 'League Spartan, sans-serif'
  },
  h2: {
    fontSize: 40,
    fontWeight: 600,
    fontFamily: 'League Spartan, sans-serif'
  },
  h3: {
    fontSize: 32,
    fontWeight: 600,
    fontFamily: 'League Spartan, sans-serif'
  },
  h4: {
    fontSize: 28,
    fontWeight: 500,
    fontFamily: 'League Spartan, sans-serif'
  },
  h5: {
    fontSize: 24,
    fontWeight: 600
  },
  h6: {
    fontSize: 20,
    fontWeight: 700
  },
  body1: {
    fontSize: 16
  },
  body2: {
    fontSize: 14
  },
  overline: {
    fontSize: 16,
    fontWeight: 700,
    textTransform: 'uppercase',
    color: 'rgba(0, 0, 0, 0.38)',
    letterSpacing: '1px'
  }
}
